var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.salesmen,"item-text":"name","item-value":"referralCode","return-object":"","clearable":"","solo":"","outlined":"","label":_vm.$t('components.salesman.select')},on:{"input":_vm.emitSalesman},model:{value:(_vm.selectedSalesman),callback:function ($$v) {_vm.selectedSalesman=$$v},expression:"selectedSalesman"}})
}
var staticRenderFns = []

export { render, staticRenderFns }